import React from 'react';
import { FadeInSection } from '../ui/MotionPrimitives';

const AboutAbout: React.FC = () => {
  return (
    <FadeInSection className="w-full bg-white py-16 md:py-20">
      <div className="mx-auto max-w-5xl px-6 md:px-10">
        <h2 className="text-[50px] font-semibold text-black md:text-[52px]">
          Our Story
        </h2>
        <p className="mt-1 text-[15px] font-medium text-black/80 md:text-base">
          Global Real Estate Investment and Advisory
        </p>

        <div className="mt-6 space-y-4 text-sm leading-relaxed text-black/80 md:text-[15px]">
          <p>
            Hogar Dorado House is a specialized real estate investment firm bringing over five years of proven
            experience in the dynamic markets of the United Arab Emirates (UAE) and the United States of America (USA).
            With a deep commitment to excellence and a strong track record of success, we are dedicated to creating
            lasting value for our clients, partners, and team members through strategic property acquisition,
            development, and management.
          </p>
          <p>
            Our commitment is to leverage deep market intelligence and a robust network to deliver exceptional returns
            and enduring value for our clients, partners, and stakeholders.
          </p>
        </div>
      </div>
    </FadeInSection>
  );
};

export default AboutAbout;
